import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

import { textareaVariants } from './textarea-variants';

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> &
  VariantProps<typeof textareaVariants> & {
    minRows?: number;
  };

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, size, radius, fullWidth = true, minRows = 3, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={minRows}
      className={cn(textareaVariants({ size, radius, fullWidth }), className)}
      {...props}
    />
  )
);
Textarea.displayName = 'Textarea';

export { Textarea };
